import { render, staticRenderFns } from "./userDeleteConformationDialog.vue?vue&type=template&id=0d8004a0&scoped=true&"
import script from "./userDeleteConformationDialog.vue?vue&type=script&lang=js&"
export * from "./userDeleteConformationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8004a0",
  null
  
)

export default component.exports